// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { getAuthToken, getCurrentUser } from '../../../utils/authHelpers';

// const PublicRoutes = ({ children }) => {
//   const isAuthenticated = getAuthToken();
//   const currentUser = getCurrentUser();
//   if (!isAuthenticated) return children;
//   const isOrg = currentUser?.userType === 'organization';
//   const redirectTo = isOrg ? '/dashboard' : '/jobseeker/dashboard';

//   return <Navigate to={redirectTo} replace />;
// };

// export default PublicRoutes;

import { Navigate } from 'react-router-dom';
import { getAuthToken, getCurrentUser } from '../../../utils/authHelpers';

const PublicRoutes = ({ children }) => {
  const token = getAuthToken();
  const user = getCurrentUser();

  if (token && user) {
    return <Navigate to={user === 'organization' ? '/dashboard' : '/jobseeker/dashboard'} replace />;
  }

  return children;
};

export default PublicRoutes;
